export const REMOVE_PASS_DESCRIPTION_1 = "This will remove the pass and its current configuration from your basket.";
export const REMOVE_PASS_DESCRIPTION_2 = "You can add it again later, but you’ll need to reconfigure it.";